export default {
    getLogDataTableOptions: state => state.logDataTableOptions,
    getLogHeaderFields: state => state.logHeaderFields,
    getLogActions: state => state.logActions,
    getLogRowActions: state => state.logRowActions,
    getDetailsDataTableOptions: state => state.detailsDataTableOptions,
    getDetailsHeaderFields: state => state.detailsHeaderFields
}
